import { render, staticRenderFns } from "./ProjectInfoCard.vue?vue&type=template&id=40d749ac&"
import script from "./ProjectInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports